module.exports = __webpack_public_path__ + "img/download_fdfm.11253dd5.svg";